(function () {
  let shareModalExists = false;

  function createShareModal(shareUrl) {
    if (shareModalExists) return; // prevent duplicate modal
    shareModalExists = true;

    const modal = document.createElement('div');
    modal.id = 'cpb-share-modal';

    const content = document.createElement('div');
    content.className = 'cpb-share-modal-content';

    const title = document.createElement('h3');
    title.textContent = 'Share Your Design';

    const input = document.createElement('input');
    input.id = 'cpb-share-input';
    input.readOnly = true;
    input.value = shareUrl;

    const copyBtn = document.createElement('button');
    copyBtn.id = 'cpb-copy-btn';
    copyBtn.className = 'cpb-share-btn-main';
    copyBtn.textContent = 'Copy link';

    const closeBtn = document.createElement('button');
    closeBtn.id = 'cpb-close-btn';
    closeBtn.className = 'cpb-share-btn-secondary';
    closeBtn.textContent = 'Close';

    content.append(title, input, copyBtn, closeBtn);
    modal.appendChild(content);
    document.body.appendChild(modal);

    input.select(); // pre-select for quick copy

    closeBtn.addEventListener('click', () => {
      modal.remove();
      shareModalExists = false;
    });

    copyBtn.addEventListener('click', () => {
      navigator.clipboard.writeText(shareUrl); // copy URL
      copyBtn.textContent = 'Copied!';
      setTimeout(() => {
        modal.remove();
        shareModalExists = false;
      }, 800);
    });
  }

  function initShareButton() {
    const container = document.querySelector('.cpb-product-actions-container');
    if (!container) return; // container missing

    if (container.dataset.shareButtonInitialized === 'true') return; // avoid re-init
    container.dataset.shareButtonInitialized = 'true';

    const topRow = document.createElement('div');
    topRow.className = 'cpb-actions-row-top';

    const bottomRow = document.createElement('div');
    bottomRow.className = 'cpb-actions-row-bottom';

    const buttons = [...container.querySelectorAll('.cpb-actions-btn, button')];
    buttons.forEach(btn => topRow.appendChild(btn)); // move existing buttons

    const shareBtn = document.createElement('button');
    shareBtn.className = 'cpb-actions-btn cpb-share-btn';
    shareBtn.textContent = 'Share Design';

    shareBtn.addEventListener('click', async () => {
      try {
        if (!window._cpb || !window._cpb.saveConfig) {
          console.error('_cpb not ready'); // API not ready
          return alert('Unable to generate share link');
        }

        const configId = await window._cpb.saveConfig(null, false); // generate config ID
        const shareUrl = `${location.origin}${location.pathname}?configid=${configId}`;

        createShareModal(shareUrl);

      } catch (err) {
        console.error(err);
        alert('Unable to generate share link');
      }
    });

    bottomRow.appendChild(shareBtn); // add share button

    container.innerHTML = ''; // rebuild structure
    container.appendChild(topRow);
    container.appendChild(bottomRow);
  }

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', initShareButton);
})();
